export const openPositions = [
  {
    url: '/lediga-tjanster',
    title: 'Redovisningskonsult',
  },
];
